module.exports = __webpack_public_path__ + "static/img/pic_ship_big.8f80ad70.png";